import {StageLayer} from "@nolimit/slot-launcher/bin/StageLayer";
import {GuiToggleButton} from "@nolimit/slot-launcher/bin/gui/buttons/GuiToggleButton";
import {PointerStateColorSet} from "@nolimit/slot-launcher/bin/gui/buttons/states/sets/PointerStateColorSet";
import {IconToggleButton} from "@nolimit/slot-launcher/bin/gui/buttons/IconToggleButton";
import {Icon} from "@nolimit/slot-launcher/bin/gui/displayobjects/Icon";
import {PointerStateIconSet} from "@nolimit/slot-launcher/bin/gui/buttons/states/sets/PointerStateIconSet";
import {BonusFeatureData} from "@nolimit/slot-launcher/bin/plugins/apiplugin/BonusFeatures";
import {BetBoostData} from "@nolimit/slot-launcher/bin/plugins/apiplugin/bethandler/BetHandler";
import {NolimitApplication} from "@nolimit/slot-launcher/bin/NolimitApplication";
import {ScreenBounds} from "@nolimit/slot-launcher/bin/display/ScreenBounds";
import {APIFeatureBetEventData} from "@nolimit/slot-launcher/bin/interfaces/APIBetEventData";
import {APIEvent} from "@nolimit/slot-launcher/bin/interfaces/APIEventSystem";
import {APIBetType} from "@nolimit/slot-launcher/bin/interfaces/APIBetType";
import {TimelineSprite} from "@nolimit/slot-launcher/bin/animation/TimelineSprite";
import {TimelineLite} from "gsap";
import {MathHelper} from "@nolimit/slot-game/bin/utils/MathHelper";
import {NineToFiveSound} from "../sound/NineToFiveSound";
import {NineToFive} from "../NineToFive";
import {GameMode} from "@nolimit/slot-game/bin/flowcontrol/GameMode";
import {NineToFivePopUpView} from "./NineToFivePopUpView";

// stolen from dj psycho lol
export class NineToFiveXBetView extends PIXI.Container implements StageLayer {

    private static BUTTON_LANDSCAPE_4BY3_POSITION: PIXI.Point = new PIXI.Point(710, 210);
    private static BUTTON_PORTRAIT_POSITION: PIXI.Point = new PIXI.Point(570, -40);

    private _buttonXBet: GuiToggleButton;
    private _betBoostAllowed: boolean = false;
    private _xBetPaused: boolean = false;
    private _xBetAttention: TimelineSprite;
    private _attentionTl: TimelineLite;
    private xBetFromClick:boolean;
    private xBetEnabled:boolean = false;

    constructor() {
        super();
        this.visible = false;
        NineToFive.apiPlugin.events.on(APIEvent.BET, (data: APIFeatureBetEventData) => this.onBet(data));
        NineToFive.apiPlugin.events.on(APIEvent.BET_BOOST, (data: any) => this.onBetBoost(data));
        this.name = "NineToFiveXBetView";
        this.init();
    }

    public onResize(): void {
        if (this._buttonXBet) {
            const bounds: ScreenBounds = NolimitApplication.screenBounds;
            if (NolimitApplication.isLandscape) {
                //const bounds: ScreenBounds = NolimitApplication.screenBounds;

                if (bounds.width <= 970) {
                    this._buttonXBet.position = NineToFiveXBetView.BUTTON_LANDSCAPE_4BY3_POSITION;
                } else {
                    const spinButtonWidth: number = 200,
                        edgeMarginX: number = 10,
                        spinCenterX: number = (bounds.right - edgeMarginX - spinButtonWidth * 0.5);
                    this._buttonXBet.position = new PIXI.Point(spinCenterX - (this._buttonXBet.width * 0.5), 250);
                }
            } else {
                this._buttonXBet.position.set(490, bounds.bottom - 290);
                //this._buttonXBet.position = NineToFiveXBetView.BUTTON_PORTRAIT_POSITION;
            }
            this._xBetAttention.position.x = this._buttonXBet.position.x - 16;
            this._xBetAttention.position.y = this._buttonXBet.position.y - 16;
        }
    }

    public removeButton(value: boolean): void {
        if (!this._betBoostAllowed) {
            return;
        }
        this.visible = value;
        this._xBetPaused = !value;

        //// #120
        //if (this._buttonXBet.toggled) {
        //    TheCage.backgroundElements.switchBgFromXBet(value);
        //}
    }

    public enableButton(value: boolean): void {
        if (!this._betBoostAllowed || this._xBetPaused) {
            return;
        }
        this._buttonXBet.enable(value);
        if (value && !this._buttonXBet.toggled) {
            this.playAttentionTl();
        } else {
            NineToFive.popUpView.hidePopUp();
            this.killAttention();
        }
    }

    public isBtnOn(): boolean {
        return this._buttonXBet.toggled;
    }

    private playAttentionTl(): void {
        if (!this._betBoostAllowed || this._xBetPaused || NineToFive.apiPlugin.freeFeatureBet.hasFreeFeatureBet()) { // #125 modified condition
            return;
        }
        const tl: TimelineLite = new TimelineLite({
            delay: MathHelper.randomNumberInRange(2.5, 5)
        });
        tl.add([
            () => {
                NineToFive.popUpView.playPopUp();
            },
            this._xBetAttention.getAnimationAutoShowHide(true, true)
        ]);
        tl.add(() => {
            this.playAttentionTl();
        });

        this._attentionTl = tl;
    }

    private killAttention(): void {
        if (this._attentionTl) {
            this._attentionTl.pause();
            this._attentionTl.kill();
        }
        this._xBetAttention?.hide();
    }

    private turnOffBoost(pauseBoost: boolean): void {
        if (!this._betBoostAllowed) {
            return;
        }
        if (this._buttonXBet.toggled) {
            this.xBetButton(false);
        }
        this._xBetPaused = pauseBoost;
    }

    private onBet(data: APIFeatureBetEventData): void {
        this.enableButton(false);
        if (data.type === APIBetType.FEATURE_BET && data.playerInteraction.featureName !== "BOOSTED_BET") {
            this.turnOffBoost(true);

            // #142
            this.killAttention();
        }

        // #124
        //TheCage.model.onBet(data);
    }

    private init(): void {
        this._betBoostAllowed = NineToFive.apiPlugin.gameClientConfiguration.boostedBetAllowed;
        if (this._betBoostAllowed) {
            const colorSet: PointerStateColorSet = new PointerStateColorSet(
                0xFFFFFFFF
            );
            const textureName01: string = "X_Bet/Xbet_";
            const onTextureName01: string = textureName01 + "On";
            const offTextureName01: string = textureName01 + "Off";

            this._buttonXBet = new IconToggleButton("level1",
                new PointerStateIconSet(
                    new Icon(NineToFive.assetLoader.getTextures(onTextureName01)[0])
                ),
                colorSet,
                new PointerStateIconSet(
                    new Icon(NineToFive.assetLoader.getTextures(offTextureName01)[0])
                ),
                colorSet
            );
            this._buttonXBet.hitArea = new PIXI.Circle(72, 72, 55);
            this._buttonXBet.addClickCallback(() => this.xBetButton(true));
            this._buttonXBet.toggled = false;
            this._buttonXBet.visible = true;
            this._buttonXBet.enable(false);

            this._xBetAttention = new TimelineSprite(NineToFive.assetLoader.getTextures("X_Bet_Attention/X_Bet_Attention_"));
            this._xBetAttention.hide();
            this._xBetAttention.blendMode = PIXI.BLEND_MODES.ADD;

            this.addChild(this._buttonXBet, this._xBetAttention);

            if (NineToFive.apiPlugin.isReplay) {
                this._buttonXBet.enable(false);
                if (NineToFive.model.initData.nextPlayerInteraction?.featureName === "BOOSTED_BET") {
                    this.turnOnBoost(true);
                } else {
                    this.turnOffBoost(true);
                }
            }

            if (NineToFive.model.isRestore) {
                if (NineToFive.model.initData.mode === GameMode.NORMAL) {
                    if (NineToFive.model.initData.boostedBet) {
                        this.turnOnBoost(false);
                    }
                }
            }

            if (NineToFive.model.isRestore) {
                const mode: string = NineToFive.model.initData.mode;

                // if current mode is any of the FS/SFS mode OR it's going to be FS/SFS
                if ((mode.indexOf("FREESPIN") > -1) || (mode.indexOf("NORMAL") > -1 && NineToFive.model.initData.nextMode.indexOf("FREESPIN") > -1)) {
                    this.visible = false;
                    if (NineToFive.model.initData.boostedBet) {
                        this.turnOnBoost(false);
                    }
                }
            }

            // #122
            if (NineToFive.apiPlugin.freeBets.hasFreeBets()) {
                this.turnOffBoost(true);
                // #145
                this.killAttention();

            }
            NineToFive.apiPlugin.freeBets.events.on(NineToFive.apiPlugin.freeBets.FREE_BETS_START, () => {
                this.turnOffBoost(true);
                // #145
                this.killAttention();
            });
            NineToFive.apiPlugin.freeBets.events.once(NineToFive.apiPlugin.freeBets.FREE_BETS_END, () => {
                this.turnOffBoost(false);
            });
            // copied from DJ psycho issue #184
            NineToFive.apiPlugin.events.on("extFreeRoundsEnded", () => {
                this._xBetPaused = false;
                this.enableButton(true);
            });


            this.onResize();
        }
    }

    private turnOnBoost(pauseBoost: boolean): void {
        if (!this._betBoostAllowed) {
            return;
        }
        if (!this._buttonXBet.toggled) {
            this.xBetButton(false);
        }
        this._xBetPaused = pauseBoost;
    }

    // lord have mercy
    private onBetBoost(data:any | undefined) {
        const gotEnabled = data != undefined;

        if (this.xBetEnabled == gotEnabled)
            return;
        else
            this.xBetEnabled = gotEnabled;

        const fromClick = this.xBetFromClick;
        if (this.xBetEnabled) {
            this.killAttention();
            NineToFive.popUpView.resetPopUp();
            NineToFive.popUpView.hidePopUp();

            // #120
            //TheCage.backgroundElements.switchBgFromXBet(true);

            // #155
            if (NineToFive.model.data.mode == GameMode.NORMAL || NineToFive.model.data.nextMode == GameMode.NORMAL) {
                NineToFive.baseGameReelView.enableXBetReel(fromClick);
            }
            if (fromClick) {
                NineToFive.soundPlayer.playSound(NineToFiveSound.X_BET_TOGGLE);
            }
            this._buttonXBet.toggled = true;
        } else {
            this.playAttentionTl();
            //TheCage.buyFeatureName = "";//#87

            // #120
            //TheCage.backgroundElements.switchBgFromXBet(false);

            // #155
            NineToFive.baseGameReelView.disableXBetReel(fromClick);
            if (fromClick) {
                NineToFive.soundPlayer.playSound(NineToFiveSound.X_BET_TOGGLE);
            }
            this._buttonXBet.toggled = false;
        }
        this.xBetFromClick = false;
    }

    private xBetButton(fromClick: boolean): void {
        if (!this._betBoostAllowed || this._xBetPaused) {
            return;
        }
        if (this._buttonXBet.toggled) {
            this.xBetFromClick = fromClick;
            NineToFive.apiPlugin.betHandler.setBoost(undefined);
        } else {
            const featureData: BonusFeatureData | undefined = NineToFive.apiPlugin.bonusFeatures.getFeatureDataByName("BOOSTED_BET");
            this.xBetFromClick = fromClick;
            if (featureData) {
                let data: BetBoostData = {
                    featureName: featureData.name,
                    price: featureData.price
                }
                NineToFive.apiPlugin.betHandler.setBoost(data);
            }
        }
        //this._buttonXBet.toggled = !this._buttonXBet.toggled;
    }
}